import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import UserDetailPage from './UserDetailPage';

type TParams = { id: string, url: string }

function Dashboard({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
            <Route exact path={`${match.url}/:userId`} component={UserDetailPage} />
        </Switch>
    );
}

export default Dashboard;
